import { useEffect, useRef, useState } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import TabBox from '../../../component/TabBox';
import SemesterStudentEnrolmentCheckViewTab1Body from './SemesterStudentEnrolmentCheckViewTab1Body';
import SemesterStudentEnrolmentCheckViewTab2Body from './SemesterStudentEnrolmentCheckViewTab2Body';
import { VIEW_SEMESTER_STUDENT_ENROLMENT_CHECK } from './../../../constant/ViewConstant';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';

const SemesterStudentEnrolmentCheckView = () => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const tab = useRef(null);

    useEffect(() => {
        var defaultTabNo = NullCheckUtil.isNotNull(queryData.tabNo) ? queryData.tabNo : 1;
        tab.current.initTab(
            [
                {
                    tabNo: 1,
                    title: '본교생 수강자격 검증',
                    element: <SemesterStudentEnrolmentCheckViewTab1Body key={1} tabNo={1} />,
                },
                {
                    tabNo: 2,
                    title: '본교생 학점교류 신청현황',
                    element: <SemesterStudentEnrolmentCheckViewTab2Body key={2} tabNo={2} />,
                },
            ],
            defaultTabNo,
        );
    }, []);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    <h2 className='con-title'>{VIEW_SEMESTER_STUDENT_ENROLMENT_CHECK.title}</h2>
                    <p className='con-title-p'>{VIEW_SEMESTER_STUDENT_ENROLMENT_CHECK.subTitle}</p>
                </div>
                <div className='sub-nav-wrap h-44'>
                    <div className='sub-nav-box'>
                        <BreadCrumb />
                    </div>
                </div>
                <TabBox ref={tab} />
            </div>
        </section>
    );
};

export default SemesterStudentEnrolmentCheckView;
